module.exports = __webpack_public_path__ + "static/media/bookmarks.5e874802.png";